import React from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import BlogCard from '../../components/BlogCard/BlogCard';
import {localePath} from '../../languages';

export default function RelatedArticles({articles}) {
    const {t, i18n} = useTranslation();
    if (!articles?.length) return null;
    return (
        <section className="blog-related" aria-labelledby="related-heading">
            <div className="blog-related-heading">
                <h2 id="related-heading">{t('blog.moreArticles')}</h2>
                <Link className="blog-back-link" to={localePath('/blog', i18n.language)}>
                    {t('blog.allArticles')}
                    <span aria-hidden="true">↗</span>
                </Link>
            </div>
            <div className="blog-related-grid">
                {articles.map((article) => (
                    <BlogCard key={article.path} article={article} heading="h3" />
                ))}
            </div>
        </section>
    );
}
